import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'

import * as input from '../../../../input'
import type * as _plugin from '../../../ec-plugin'
import { AtnDsTableStore } from '../../../store'

@ngCore.Component({
  imports: [
    ngCommon.NgClass,
    input.select.single.Component,
    input.text.Component,
  ],
  selector: 'embedded-pagination',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link AtnDsTableStore} */
  public store = ngCore.inject(AtnDsTableStore)

  /** @see {@link _plugin.Config.supportedPageSizes} */
  // Explicitly typing to ensure type safety and prevent accidental type errors
  public readonly supportedPageSizesSg = ngCore.computed<
    readonly input.select.models.Item<number>[]
  >(
    (_pluginConfig = this.store.pluginConfigSg()) =>
      _pluginConfig?.supportedPageSizes.map(value => ({
        label: value.toString(),
        value,
      })) ?? [],
  )

  /** TODO: */
  public quantityChangeHandler(newQuantity: number | undefined) {
    const plugin = this.store.pluginSg()
    plugin?.collection.plugins.currentListPlugin.appliedParams.actions.setQuantity
      .from('Table.Pagination.Quantity.Changed')
      .dispatch(newQuantity)
  }

  /** TODO: */
  public previousArrowClickHandler() {
    const plugin = this.store.pluginSg()
    plugin?.feature.actions.changePage
      .from('Table.Pagination.Arrow.Previous.Click')
      .dispatch({ previous: true })
  }
  public nextArrowClickHandler() {
    const plugin = this.store.pluginSg()
    plugin?.feature.actions.changePage
      .from('Table.Pagination.Arrow.Next.Click')
      .dispatch({ next: true })
  }

  /** TODO: */
  // Accepts number or string, due to the fact, that through input component we can input string
  public pageChangeHandler(
    source: 'Clicked' | 'Changed',
    page: number | string | undefined,
  ) {
    page = Number(page)
    if (isNaN(page)) {
      console.warn('Invalid value provided for page number')
      return
    }
    const plugin = this.store.pluginSg()

    plugin?.feature.actions.changePage
      .from(`Table.Pagination.Page.${source}`)
      .dispatch({ page })
  }
}
